// Components
import useTranslate from "hooks/useTranslate";
import ProviderItem from "../../atoms/ProviderItem";

// Constants
import { INFO_PARTNER_LIST } from "../../../constants/partners";

// Hooks

import "./styles.sass";

const ProviderInfo = () => {
  const t = useTranslate();

  return (
    <div className="ProviderInfo">
      <span className="ProviderInfo__name">{t("info.providers.title")}</span>
      <div className="ProviderInfo-list">
        <div className="ProviderInfo-list__mobile">
          {INFO_PARTNER_LIST.map((item) => (
            <ProviderItem key={item.id} icon={item.icon} title={item.title} />
          ))}
        </div>
        <div className="ProviderInfo-list__fist">
          {INFO_PARTNER_LIST.slice(0, 3).map((item) => (
            <ProviderItem key={item.id} icon={item.icon} title={item.title} />
          ))}
        </div>
        <div className="ProviderInfo-list__second">
          {INFO_PARTNER_LIST.slice(3, 7).map((item) => (
            <ProviderItem key={item.id} icon={item.icon} title={item.title} />
          ))}
        </div>
        <div className="ProviderInfo-list__third">
          {INFO_PARTNER_LIST.slice(7).map((item) => (
            <ProviderItem key={item.id} icon={item.icon} title={item.title} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProviderInfo;
